import ClientesUI from '../../Admin/Clientes/ClientesUI';

const ClientesOperacionesUI = () => {
  return <ClientesUI apiBasePath="/api/operaciones/clientes" />;
};

export default ClientesOperacionesUI;
